import React from "react";

export const ProgressBar = ({ noOfActive, total }) => {
  return (
    <div className="df-progress-bar">
      {Array.from({ length: total }).map((data, index) => (
        <div
          key={index}
          className={`df-step ${index < noOfActive ? "active" : ""}`}
        ></div>
      ))}
    </div>
  );
};
